import { Card, Button, Affix, Form } from "antd";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useNavigate } from "react-router-dom";
import ProcessForm from "./ProcessForm";

const AddProcess = (props) => {
  const { width } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const discartForm = () => {
    navigate("/tanda/process");
  };
  const addNewProcess = () => {
    form.submit();
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title="Add New Process"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Button size="small" key={1} danger onClick={() => discartForm()}>
                Discard
              </Button>,
              <Button
                size="small"
                key={2}
                type="primary"
                onClick={() => addNewProcess()}
              >
                Add Process
              </Button>,
            ]}
          />
        </Card>
      </Affix>

      <ProcessForm form={form} />
    </>
  );
};

export default AddProcess;
